import React from "react";
import AOS from 'aos';
import {Link} from "react-router-dom";
import "bootstrap/dist/js/bootstrap.bundle.min";

AOS.init();

const HowToPay = () => {
  const styles = {
    section: {
      background: "linear-gradient(135deg, #f8f9fa 0%, #e8f4f8 100%)",
      paddingTop: "60px",
      paddingBottom: "80px",
      overflowX: "hidden"
    },
    grid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
      gap: "24px",
      maxWidth: "1200px",
      margin: "0 auto",
      padding: "0 24px"
    },
    card: {
      background: "#ffffff",
      borderRadius: "20px",
      overflow: "hidden",
      boxShadow: "0 8px 30px rgba(23, 57, 98, 0.1)",
      transition: "all 0.3s ease",
      cursor: "pointer",
      textDecoration: "none",
      color: "inherit",
      display: "block"
    },
    cardImage: {
      height: "200px",
      width: "100%",
      objectFit: "contain",
      padding: "24px",
      background: "linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)"
    },
    cardBody: {
      padding: "24px",
      textAlign: "center"
    },
    cardTitle: {
      fontFamily: "'Century Gothic', -apple-system, sans-serif",
      fontSize: "1.5rem",
      fontWeight: "700",
      color: "#173962",
      marginBottom: "16px"
    },
    cardText: {
      fontSize: "1rem",
      lineHeight: "1.6",
      color: "#4a4a6a"
    },
    highlight: {
      fontWeight: "600",
      color: "#173962"
    }
  };

  const paymentMethods = [
    {
      title: "Checks",
      image: require('../../Assets/img/How To Pay Page/cheque.png'),
      description: "If you prefer to pay by check, contact us and we will make the arrangements",
      link: null
    },
    {
      title: "Cash",
      image: require('../../Assets/img/How To Pay Page/cash.png'),
      description: "Cash is always preferred if possible. Contact Us to set up a Drop off/ Pick up time.",
      link: null
    },
    {
      title: "Credit Card",
      image: require('../../Assets/img/How To Pay Page/credit-card.png'),
      description: "NeedForGeeks accepts all major credit cards! A 3% processing fee will apply for this method",
      link: null
    },
    {
      title: "PayPal",
      image: require('../../Assets/img/How To Pay Page/paypal.png'),
      description: <>Use <span style={styles.highlight}>payments@needforgeeks.com</span> with PayPal and choose the "Friends and Family" option to avoid unnecessary fees.</>,
      link: "https://www.paypal.com"
    },
    {
      title: "Venmo",
      image: require('../../Assets/img/How To Pay Page/venmo.png'),
      description: <>The easiest way to pay and avoid all fees. Our VENMO username is <span style={styles.highlight}>NeedForGeeks</span></>,
      link: "https://www.venmo.com"
    },
    {
      title: "Zelle QuickPay",
      image: require('../../Assets/img/How To Pay Page/Zelle.png'),
      description: <>We accept Zelle Quickpay transfers sent to: <span style={styles.highlight}>payments@needforgeeks.com</span></>,
      link: "https://www.zellepay.com"
    }
  ];

  const CardWrapper = ({ link, children }) => {
    if (link) {
      return (
        <Link to={{ pathname: link }} target="_blank" style={styles.card} data-aos="fade-up">
          {children}
        </Link>
      );
    }
    return <div style={styles.card} data-aos="fade-up">{children}</div>;
  };

  return (
    <div>
      <div className="page-content">
        <div className="jumbotron jumbotron-fluid m-0" id="how-to-pay" style={styles.section}>
          <div style={styles.grid}>
            {paymentMethods.map((method, index) => (
              <CardWrapper key={index} link={method.link}>
                <img style={styles.cardImage} src={method.image} alt={method.title} />
                <div style={styles.cardBody}>
                  <h5 style={styles.cardTitle}>{method.title}</h5>
                  <p style={styles.cardText}>{method.description}</p>
                </div>
              </CardWrapper>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default HowToPay;
